import React from 'react';
import PropTypes from 'prop-types';
import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';
import regularFont from '../../assets/fonts/Metropolis-Regular.ttf';
import boldFont from '../../assets/fonts/Metropolis-SemiBold.ttf';
import utils from '../../utils/utils';
import DATE_FORMAT from '../../components/constants/dateFormat';

const PackerDeliveryDayMarketplacePdf = ({ combinedOrderItems, deliveryDayMarketplace, copy }) => {
  const BORDER_COLOR = '#000';
  const BORDER_STYLE = 'solid';

  Font.register({
    family: 'metropolis',
    fonts: [{ src: regularFont }, { src: boldFont, fontWeight: 600 }],
  });

  // disable hyphenation
  Font.registerHyphenationCallback((word) => [word]);

  const styles = StyleSheet.create({
    body: {
      padding: 5,
      fontSize: 12,
      fontFamily: 'metropolis',
    },
    title: {
      fontSize: 20,
      marginTop: 10,
      marginBottom: 10,
    },
    h3: {
      fontSize: 16,
    },
    small: {
      fontSize: 10,
    },
    bold: {
      fontWeight: 700,
    },
    info: {
      marginBottom: 10,
    },
    table: {
      display: 'table',
      width: 'auto',
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row',
    },
    tableColHeader: {
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      fontSize: 10,
    },
    tableCol: {
      borderStyle: BORDER_STYLE,
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCol1: {
      width: '70%',
    },
    tableCol2: {
      width: '15%',
    },
    tableCol3: {
      width: '15%',
    },
    tableCellHeader: {
      margin: 5,
      fontWeight: 700,
    },
    tableCell: {
      margin: 5,
      paddingTop: 5,
    },
    footer: {
      position: 'absolute',
      bottom: 30,
      left: 30,
    },
  });

  return (
    <Document>
      <Page size="A6" style={styles.body}>
        <Text style={styles.title}>{`${deliveryDayMarketplace.marketplaceName} ${utils.getFormattedDateFromString(
          deliveryDayMarketplace.deliveryDate,
          DATE_FORMAT.displayOnlyDate
        )}`}</Text>
        <Text style={styles.info}>{`DDM${deliveryDayMarketplace.id}`}</Text>

        <View style={[styles.table, { marginBottom: 5 }]}>
          <View style={styles.tableRow}>
            <View style={[styles.tableColHeader, styles.tableCol1]}>
              <Text style={styles.tableCellHeader}>{copy.table.itemName}</Text>
            </View>
            <View style={[styles.tableColHeader, styles.tableCol2]}>
              <Text style={styles.tableCellHeader}>{copy.table.quantity}</Text>
            </View>
            <View style={[styles.tableColHeader, styles.tableCol3]}>
              <Text style={styles.tableCellHeader}>{copy.table.status}</Text>
            </View>
          </View>
          {combinedOrderItems.map((combinedOrderItem, index) => {
            return (
              <View key={index} style={styles.tableRow}>
                <View style={[styles.tableCol, styles.tableCol1]}>
                  <Text style={styles.tableCell}>{combinedOrderItem.orderItem.itemName}</Text>
                </View>
                <View style={[styles.tableCol, styles.tableCol2]}>
                  <Text style={styles.tableCell}>{combinedOrderItem.quantity}</Text>
                </View>
                <View style={[styles.tableCol, styles.tableCol3]}>
                  <Text style={styles.tableCell}></Text>
                </View>
              </View>
            );
          })}
        </View>
      </Page>
    </Document>
  );
};

PackerDeliveryDayMarketplacePdf.propTypes = {
  combinedOrderItems: PropTypes.array.isRequired,
  deliveryDayMarketplace: PropTypes.object.isRequired,
  copy: PropTypes.object.isRequired,
};

PackerDeliveryDayMarketplacePdf.defaultProps = {};

export default PackerDeliveryDayMarketplacePdf;
